module.exports = __webpack_public_path__ + "img/branton-prepack-preview.1672c0fd.jpg";